import classNames from "classnames";
import React, { FC } from "react";

import style from "./CountryFlag.module.scss";

export const CountryFlag: FC<{ countryCode: string; className?: string }> = ({ countryCode, className = "" }) => (
  <img
    src={require(`nvent-web/assets/svg/country-flags/${countryCode.toLowerCase()}.svg`)}
    alt={countryCode}
    className={classNames(style.flag, className)}
  />
);
